module.exports = __webpack_public_path__ + "static/media/totp.bc448357.png";